import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import PersonIcon from "@mui/icons-material/Person";
import { Avatar, Card, IconButton, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_COACHING } from "../../constant/Apipath";
import ClientCoachingAddModal from "./ClientCoachingAddModal";
import TabsComponent from "../component/TabsComponent";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { useLocation } from "react-router-dom";

function Coaching() {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientCoaching(multiLanguageData?.ClientCoaching || {});
  const { TEXT_RECEIVED, TEXT_SUBMITTED, TEXT_SUBMITTED_ANONYMOUSLY,TEXT_EMPTY_RECEIVED,TEXT_EMPTY_SUBMITTED } = LANGUAGE;

  const [coachingData, setCoachingData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [viewAddModel, setViewAddModel] = useState(false);
  const location = useLocation();

  useEffect(() => {
    getCoachingData(1);
  }, [currentTab, location]);

  const getCoachingData = async (pageNo) => {
    setIsLoading(true);
    try {
      const obj = {
        PageNr: pageNo,
        NrOfRecPerPage: 20,
        FullSearch: location?.state?.searchText || "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            [getField()]: getFieldData(),
            ClientId:selectedClientData?.ClientId
          }
        ],
        SortList: [
          {
            FieldName: "Id",
            Direction: "DESC"
          }
        ]
      };

      const coachingResponse = await Postrequestcall(
        FETCH_CLIENT_COACHING,
        obj,
        loginData?.accessToken
      );
      if (coachingResponse.status === 200) {
        if (pageNo === 1) {
          setCoachingData(coachingResponse?.data?.data);
        } else {
          setCoachingData((prevData) => [...prevData, ...coachingResponse?.data?.data]);
        }
        setPageNo(pageNo + 1);
        if (coachingResponse?.data?.data?.length === 0) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      } else {
        setCoachingData([]);
      }
    } catch (error) {
      setCoachingData([]);
      console.log("getCoachingData-> Error When Getting Coaching Data: ", error);
    }
    setIsLoading(false);
  };

  //   SETTING API'S OBJECT FIELD BASED ON TAB
  const getField = () => {
    switch (currentTab) {
      case 0:
        return "supervisorUserId";
      case 1:
        return "createdBy";
    }
  };
  const getFieldData = () => {
    switch (currentTab) {
      case 0:
        return selectedClientData?.ClientEmployeeId;
      case 1:
        return loginData?.userInformation?.UserId;
    }
  };

  const handleToggleAddModel = async (loadNew) => {
    setViewAddModel(!viewAddModel);
    if (loadNew === true) {
      await getCoachingData(1);
    }
  };

  const CustomListing = ({ data, index }) => {
    return (
      <Card
        key={index}
        sx={{
          boxShadow: "none",
          borderRadius: "10px",
          marginBottom: "10px",
          padding: "15px"
        }}>
        <Stack spacing={2}>
          <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction="row" width="100%">
            {data.submitAnonymously ? (
              <Stack direction="row" sx={{ alignItems: "center" }} spacing={1}>
                <Typography variant="body1" sx={{ color: "text.secondary" }}>
                  {TEXT_SUBMITTED_ANONYMOUSLY}
                </Typography>
              </Stack>
            ) : (
              <Stack direction="row" sx={{ alignItems: "center" }} spacing={1}>
                <Avatar src={data.userProfilePicture} />
                <Typography variant="body1">{data.createdByUser}</Typography>
              </Stack>
            )}
            <Typography variant="body1" sx={{ color: "text.secondary" }}>
              {dayjs(data.dateCreated).format("MMMM DD, YYYY")}
            </Typography>
          </Stack>

          <Typography variant="body1" sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <PersonIcon sx={{ color: selectedClientData?.AccentColor }} />{" "}
            <span>{data?.clientEmployeeName}</span>
          </Typography>
          <Typography variant="body1">{data.description}</Typography>
        </Stack>
      </Card>
    );
  };

  const handleChange = (newValue) => {
    if(currentTab !== newValue){
    setPageNo(1);
    setCoachingData([]);
    setCurrentTab(newValue);
    }
  };

  const Tabs = [
    {
      label: "Received",
      value: 0,
      translateLabel: TEXT_RECEIVED
    },
    {
      label: "Submitted",
      value: 1,
      translateLabel: TEXT_SUBMITTED
    }
  ];

  return (
    <>
      <TabsComponent
        tabValue={currentTab}
        style={{
          marginBottom: "10px"
        }}
        tabs={Tabs}
        setTabsValue={handleChange}
      />

      {isLoading ? (
        <Loader fullScreen />
      ) : (
        <>
          {coachingData?.length == 0 ? (
            <>
              <Stack
                sx={{
                  height: "85vh",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                {currentTab === 0 ? (
                    <Typography>{TEXT_EMPTY_RECEIVED}</Typography>
                ) : (
                  <Typography>{TEXT_EMPTY_SUBMITTED}</Typography>
                )}
              </Stack>
            </>
          ) : (
            <div
              id="coaching_div"
              style={{
                maxHeight: "85vh",
                overflow: "auto",
                scrollbarWidth: "none"
              }}>
              <InfiniteScroll
                scrollableTarget="coaching_div"
                dataLength={coachingData?.length}
                next={() => getCoachingData(pageNo)}
                hasMore={hasMore}
                loader={<Loader />}>
                {coachingData?.map((data, index) => (
                  <CustomListing key={index} index={index} data={data} />
                ))}
              </InfiniteScroll>
            </div>
          )}
        </>
      )}
      {viewAddModel && (
        <ClientCoachingAddModal open={viewAddModel} handleClose={handleToggleAddModel} />
      )}
      <div className="button-div">
        <IconButton
          className="icon-button"
          sx={{ backgroundColor: selectedClientData?.AccentColor }}
          onClick={handleToggleAddModel}>
          <AddIcon className="add-icon" />
        </IconButton>
      </div>
    </>
  );
}

export default Coaching;
